module.exports = __webpack_public_path__ + "img/chart.191beef8.svg";